;(function ($) {
  /**
   * -------------------
   * DEFAULT SCRIPTS
   * -------------------
   * Comment out the scripts you are not using. The compiler will get rid of the comments and minify for you.
   */

  $(window).on('load', function () {
    // So we can re-use this function in other JS files where needed
    // Mostly for re-initializing components if a plugin alters the dom
    window.reInitColourSelect = initSnippetProductColorSelect
    window.productHover = initProductHover
    window.headerHeight = document.querySelector('header').offsetHeight

    responsiveAnnouncementBar()
    // Temporary (i hope)
    //initSnippetProductColorSelect()
    initProductHover()
    initProductHeroHover();
    formSubmit();

    // Readmore / readless
    if( $('.readmore').length ) {

      var toggleReadmore = (e) => {
         var $container = $(e.target).parents('.swiper-slide');
         var $swiper = $(e.target).parents('.swiper-container');

         $container.find('.fulldesc, .cutdesc').toggleClass('d-none');
         
         if( $swiper.length ) {

           var unReadMore = (e) => {
              $container.find('.fulldesc, .cutdesc').toggleClass('d-none');

              // Unbind this handler
              e.eventsListeners.slideChange.pop();
           }
          $swiper[0].swiper.on('slideChange', unReadMore);
         }
      }

       $('.readmore, .readless').on('click', toggleReadmore);

    }

    // Reviews HTML alterations
    if ($('.jdgm-histogram__frequency').length) {
      $('.jdgm-histogram__frequency').each(function () {
        this.innerHTML = this.innerHTML.slice(1, -1) + ' REVIEWS'
      })
    }
    // Accordion for FAQs (jQuery)
    $('.accordion dt.active')
      .next()
      .slideDown()
    $('.accordion').on('click', 'dt', function () {
      $('.accordion dd').slideUp()

      if (!$(this).hasClass('active')) {
        // remove active class from any others that might be active
        $('.accordion dt.active').removeClass('active')
        $(this).addClass('active')
        $(this)
          .next()
          .slideDown()
      } else {
        $(this).removeClass('active')
      }
    })

    // Hamburger
    $('.header-hamburger').click(function () {
      $('body').toggleClass('menu-closed')
    })

    // Search modal
    $('.search-action').on('click', function () {
      $('body').toggleClass('search-active')
      if ($('body').hasClass('search-active')) {
        $('.search-modal input').focus()
        $('body').on('click', function (e) {
          if (
            !$(e.target).parents('.search-modal').length &&
            !$(e.target).parents('.top-header__search').length
          ) {
            $('body').removeClass('search-active')
            $('body').unbind('click')
          }
        })
      }
    })

    // Components loading animations
    $('.view-animation').viewportChecker({
      classToAdd: 'animated',
      offset: 20
    })

    // Lazyload
    $('.lazyload').Lazy({
      effect: 'fadeIn',
      visibleOnly: true,
      onError: function (element) {
        console.log('error loading ' + element.data('src'))
      }
    })

    $(document).on('click', '.inline-video-trigger', function () {
      if ($(this).data('video-id')) {
        if ($(this).hasClass('vimeo')) {
          var iframeHTML =
            '<iframe src="https://player.vimeo.com/video/' +
            $(this).attr('data-video-id') +
            '?title=0&byline=0&portrait=0?&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
        } else {
          var iframeHTML =
            '<iframe src="https://www.youtube.com/embed/' +
            $(this).attr('data-video-id') +
            '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        }

        $(this)
          .parent('.video-preview-container')
          .find('.inline-video-trigger')
          .hide()
        $(this)
          .parent('.video-preview-container')
          .find('.overlay')
          .hide()
        $(this)
          .parent('.video-preview-container')
          .find('iframe')
          .remove()
        $(this)
          .parent('.video-preview-container')
          .append(iframeHTML)
      } else {
        console.error('no video ID provided.')
      }
    })

    // get all sliders, we need to loop them due to different settings + nav
    var swipers = document.querySelectorAll(
      '.swiper-container:not(.control):not(.mobile)'
    )
    swipers.forEach(function (el, index) {
      var closestSection = el.closest('section')
      var controls = closestSection.querySelector('.control')
      var recommended = closestSection.classList.contains('section-recommend')
      var productSingle = closestSection.classList.contains(
        'section-producthero'
      )
      var testimonials = closestSection.classList.contains(
        'section-testimonials'
      )

      // slider settings
      var options = {
        speed: 600,
        loop: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        thumbs: {}
      }

      if (recommended || testimonials) {
        options.slidesPerView = 1
        options.breakpoints = {
          999: {
            slidesPerView: 3
          }
        }
      }

      if (testimonials) {
        options.spaceBetween = 10
        options.navigation = {
          nextEl: '.swiper-button-next.alt',
          prevEl: '.swiper-button-prev.alt'
        }
        options.pagination = {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      }

      // For gallery sliders
      if (controls) {
        options.thumbs.swiper = new Swiper(controls, {
          speed: 600,
          loop: false,
          slidesPerView: 3,
          spaceBetween: 10,
          freeMode: true,
          centeredSlides: false,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true
          },
          breakpoints: {
            320: {
              slidesPerView: 2
            },
            480: {
              slidesPerView: 3
            }
          }
        })
      }
      // init slider
      new Swiper(el, options)
    })

    // Phone Concatenation Script For Tracking
    setTimeout(function () {
      $('.phone-text em').each(function () {
        var unsliced = $(this).text()
        var sliced = unsliced.slice(0, -2) + '...'
        $(this).text(sliced)
        var linked = 'tel:' + unsliced.replace(/\s/g, '')
        $(this).click(function () {
          if ($(window).width() < 1000) {
            window.location.href = linked
          } else {
            $(this).text(unsliced)
          }
        })
      })
    }, 3000)

    if ($('#timer').length) {
      var timeduration = $('.announcements').data('duration')
      var timetype = $('.announcements').data('type')
      startTimer(timeduration, timetype, $('#timer')[0])
    }
  })


  function initProductHeroHover() {
    if( $('.gallery-top img').length && $('.pswp').length ) {
      var items = [];
   
      $('.gallery-top img').each(function() {

        $(this).css('cursor', 'zoom-in');
        
        var size = $(this).attr('data-size').split('x');
        items.push({
          src: $(this).attr('data-zoom'),
          w: size[0],
          h: size[1]
        })
      })

      var openPhotoSwipe = function(index) {
        var options = {
          index : index
        }
        var gallery = new PhotoSwipe($('.pswp')[0], PhotoSwipeUI_Default, items, options);
        gallery.init();
      }

      $('.gallery-top .swiper-slide').on('click', function() {
        var index = $(this).index();
        openPhotoSwipe(index);
      })
     
    }
  }

  // Sticky Header
  $(window).on('scroll load', function () {
    if ($(window).scrollTop() >= 50) {
      $('header').addClass('scrolled')
    } else {
      $('header').removeClass('scrolled')
    }
  })

  // Smooth Scroll To Form
  $(document).on('click', '.js-cta', function () {
    target = $(this).attr('data-target')

    if (target.length) {
      $('html, body').animate(
        {
          scrollTop: $(target)
            .find('form')
            .offset().top
        },
        1500
      )
    }
  })

  // Smooth Scroll To Anchor
  $(document).on('click', '.js-cta--reg', function () {
    target = $(this).attr('data-target')

    if (target.length) {
      $('html, body').animate(
        {
          scrollTop: $(target).offset().top - window.headerHeight
        },
        1000
      )
    }
  })

  function responsiveAnnouncementBar () {
    // announcement bar can be of varying height due to content, especially mobile
    // this just creates css for the fixed header so the offset values are correct
    var anHeight = document.querySelector('.top-header').offsetHeight

    var newStyles =
      '' +
      'body header.scrolled {' +
      'transform: translateY(-' +
      anHeight +
      'px);' +
      '}'

    newStyles +=
      '' + 'body {' + 'padding-top: ' + window.headerHeight + 'px;' + '}'

    document.querySelector('#header-styles').innerHTML = newStyles
    delete newStyles
  }

  var resizeTimer
  $(window).bind('resize', function () {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(function () {
      responsiveAnnouncementBar()
    }, 100)
  })

  // Exit intent
  var hasOpenedModal = false
  if (!getCookie('nlpopup-' + window.sitename)) {
    setTimeout(function () {
      document.addEventListener('mouseout', function (evt) {
        if (
          !evt.toElement &&
          !evt.relatedTarget &&
          !hasOpenedModal &&
          !$('#prescribeForm').hasClass('show')
        ) {
          $('#newsletterForm').modal(true)
          hasOpenedModal = true
          setCookie('nlpopup-' + window.sitename, true, 1)
        }
      })
    }, 3000)
  }
  function setCookie (name, value, days) {
    var expires = ''
    if (days) {
      var date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
  }
  function getCookie (name) {
    var nameEQ = name + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }

  // Countdown timer
  function startTimer (duration, type, display) {
    var timer = duration
    var minutes, seconds, hours, days
    var now = Math.floor(Date.now() / 1000)

    if (type == 'evergreen') {
      var nearestblock = Math.ceil(now / (duration * 60)) * (duration * 60)
      timer = nearestblock - now
    }

    if (type == 'to_date') {
      var dateparts = duration.split(' ')[0]
      var timeparts = duration.split(' ')[1]

      // we need to 0 index the month
      var datestring =
        dateparts[0] + '-' + (dateparts[1] - 1) + '-' + dateparts[2] + ' '
      datestring += timeparts
      var todate = Date.parse(duration) / 1000
      timer = todate - now
    }

    setInterval(function () {
      minutes = parseInt(timer / 60, 10) % 60
      seconds = parseInt(timer % 60, 10)

      hours = parseInt(timer / 60 / 60, 10) % 24
      days = parseInt(timer / 60 / 60 / 24, 10)

      days = days < 10 ? '0' + days : days
      hours = hours < 10 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds

      if (days > 0) {
        display.textContent = days + ':' + hours + ':' + minutes + ':' + seconds
      } else {
        display.textContent = hours + ':' + minutes + ':' + seconds
      }

      if (--timer < 0) {
        timer = 0
        hideBar()
      }
    }, 1000)

    function hideBar () {
      if ($('.announcements').hasClass('hide-after-time')) {
        $('body').removeClass('has-announcements')
        $('.main-header').addClass('hide-announcements')
      }
    }
  }

  function initProductHover () {
    if (
      $('.snippet-product__view').length &&
      $('.snippet-product__view').find('img.inactive')
    ) {
      var swapImg = (active, inactive) => {
        active
          .addClass('d-none')
          .removeClass('active')
          .addClass('inactive')
        inactive
          .removeClass('d-none')
          .addClass('active')
          .removeClass('inactive')
      }

      $('.snippet-product__view').each(function () {
        var active = $(this).find('img.active')
        var inactive = $(this).find('img.inactive')

        if (inactive.length) {
          $(this).on('mouseover touchstart', function () {
            swapImg(active, inactive)

            $(this).on('mouseleave', function () {
              swapImg(inactive, active)
              $(this).unbind('mouseleave')
            })
          })
        }
      })
    }
  }

  function formSubmit() {

    $('[data-zapier]').on('submit', function(e){
      e.preventDefault();

      var url = $(this).attr('action');
      var data = $(this).serialize();
      var redirect = $(this).attr('data-redirect');
      var form = $(this)[0];

      $(this).find('[type=submit]').html('SENDING...');

      $.ajax({
        url: url,
        type: 'POST',
        data: data,
        contentType: 'application/x-www-form-urlencoded',
        cors: true,
        secure: true,
        success: function(e){
          console.log(e);
          window.dataLayer.push({
            event: 'gtm.formSubmission',
            form: form
          });
          window.location.href = redirect;
        },
        error: function(e) {
          console.log(e);
        }
        
      })
    }) 

  }

  // Product color select
  function initSnippetProductColorSelect () {
    function toggleColor (elm, product) {
      // Make current selection inactive
      elm.parentElement.querySelector('.active').classList.remove('active')
      // Make new selection active
      elm.classList.add('active')
      // Find the image and hide it
      product.find('img.active').removeClass('active')
      // Find new image and show it
      product.find('img' + elm.dataset.img).addClass('active')
      // Update the form so that it's correct when they access the product page
      product
        .find('input[name="color"]')
        .attr('value', elm.dataset.img.replace('.', ''))
    }

    // Swap between images when selecting product colour
    var products = document.getElementsByClassName('snippet-product')

    for (var i = 0; i < products.length; i++) {
      var currentProduct = products[i]

      $(currentProduct)
        .find('.snippet-product__color a')
        .on('click', function (e) {
          // If the colour has an actual image, toggle it. Otherwise just leave the image as-is
          // The dataset.img var is set within liquid, based on whether the image array contains the image we need.
          if (e.target.dataset.img != 'detach' && e.target.dataset.img != '.') {
            toggleColor(e.target, $(this).parents('.snippet-product'))
          }
        })
    }
  }
})(jQuery)

;(function ($) {
  // mobile sliders, like logo rows etc
  // need to loop in order to get the slide count
  var resizeTimer,
    mobileSwiperSlider = [],
    mobileSwiperCount
  $(window).on('resize load', function () {
    clearTimeout(resizeTimer)
    mobileSwiperSlider.forEach(function (slider, index) {
      if (
        typeof slider !== 'undefined' ||
        window.matchMedia('(min-width:1140px)').matches
      ) {
        slider.destroy()
      }
    })
    resizeTimer = setTimeout(function () {
      mobileSwiperCount = 0
      var mobileSwipers = document.querySelectorAll('.swiper-container.mobile')

      mobileSwipers.forEach(function (el, index) {
        var options = {
          speed: 600,
          slidesPerView: 2,
          spaceBetween: 10,
          watchOverflow: true,
          loop: true,
          simulateTouch: false,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: 3
            }
          }
        }

        // init slider
        if (!window.matchMedia('(min-width:1140px)').matches) {
          mobileSwiperSlider[mobileSwiperCount] = new Swiper(el, options)
          mobileSwiperCount++
        }
      })
    }, 500)
  })
})(jQuery)
